import { useState, useEffect } from "react";
import { II } from "../../components/common/Icons";
import HrModal from "./HrModal";
import api from "../../services/api";
import T from '../../assets/styles/theme';import "../../assets/styles/HR/PerformancePg.css";

function PerformancePg() {
  const [cycles, setCycles] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [showReviews, setShowReviews] = useState(false);
  const [showEditReview, setShowEditReview] = useState(false);
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [selectedReview, setSelectedReview] = useState(null);
  const [suc, setSuc] = useState("");
  const [form, setForm] = useState({ name: "", start_date: "", end_date: "" });
  const [reviewForm, setReviewForm] = useState({ rating: "", mgr_rating: "", goals: "", achievements: "", feedback: "", status: "" });

  const fetchCycles = async () => {try {setLoading(true);const data = await api.getPerformanceCycles();setCycles(data || []);} catch (e) {console.error("Cycles:", e.message);} finally {setLoading(false);}};
  useEffect(() => {fetchCycles();}, []);

  const createCycle = async () => {
    if (!form.name) {alert("Cycle name is required");return;}
    try {
      const resp = await api.createPerformanceCycle({ name: form.name, start_date: form.start_date || null, end_date: form.end_date || null });
      setSuc(`Cycle created! ${resp.employeesAdded || 0} employees added.`);
      setTimeout(() => setSuc(""), 5000);
      setShowCreate(false);setForm({ name: "", start_date: "", end_date: "" });
      fetchCycles();
    } catch (e) {alert("Error: " + e.message);}
  };

  const updateStatus = async (cycleId, status) => {
    try {
      await api.updatePerformanceCycle(cycleId, { status });
      setSuc(`Cycle status updated to ${status}`);setTimeout(() => setSuc(""), 4000);
      fetchCycles();
    } catch (e) {alert("Error: " + e.message);}
  };

  const deleteCycle = async (cycleId) => {
    if (!window.confirm("Delete this cycle and all its reviews?")) return;
    try {
      await api.deletePerformanceCycle(cycleId);
      setSuc("Cycle deleted.");setTimeout(() => setSuc(""), 4000);
      fetchCycles();
    } catch (e) {alert("Error: " + e.message);}
  };

  const viewReviews = async (cycle) => {
    setSelectedCycle(cycle);
    try {const data = await api.getPerformanceReviews(cycle.cycle_id);setReviews(data || []);setShowReviews(true);} catch (e) {alert("Error: " + e.message);}
  };

  const openEditReview = (review) => {
    setSelectedReview(review);
    setReviewForm({
      rating: review.rating || "", mgr_rating: review.mgr_rating || "",
      goals: review.goals || "", achievements: review.achievements || "",
      feedback: review.feedback || "", status: review.status || "Pending"
    });
    setShowEditReview(true);
  };

  const saveReview = async () => {
    try {
      const data = {};
      if (reviewForm.rating) data.rating = parseFloat(reviewForm.rating);
      if (reviewForm.mgr_rating) data.mgr_rating = parseFloat(reviewForm.mgr_rating);
      if (reviewForm.goals) data.goals = reviewForm.goals;
      if (reviewForm.achievements) data.achievements = reviewForm.achievements;
      if (reviewForm.feedback) data.feedback = reviewForm.feedback;
      if (reviewForm.status) data.status = reviewForm.status;
      await api.updatePerformanceReview(selectedReview.id, data);
      setSuc("Review updated!");setTimeout(() => setSuc(""), 4000);
      setShowEditReview(false);
      if (selectedCycle) viewReviews(selectedCycle);
      fetchCycles();
    } catch (e) {alert("Error: " + e.message);}
  };

  const fmtDate = (d) => {if (!d) return "—";try {return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });} catch (e) {return d;}};

  if (loading) return <div className="performancepg-inline-1"><div className="ob-pending-dot performancepg-inline-2"></div><div style={{ "--performancepg-1-color": T.textLight }} className="performancepg-dyn-1">Loading performance data...</div></div>;

  return <div><div className="sec performancepg-inline-3">
    <span>Performance & Reviews</span>
    <button className="btn btn-s" onClick={() => setShowCreate(true)}>{II("plus", 14)} New Cycle</button>
  </div>
  {suc && <div className="toast">{II("chk", 16, { c: "#2563eb" })} {suc}</div>}

  {/* KPI Cards */}
  <div className="kpi performancepg-inline-4">
    {[
      { l: "Total Cycles", v: String(cycles.length), ch: `${cycles.filter((c) => c.status === "In Progress").length} active`, cl: "#7c3aed" },
      { l: "In Progress", v: String(cycles.filter((c) => c.status === "In Progress").length), ch: "Current review cycles", cl: "#2563eb" },
      { l: "Completed", v: String(cycles.filter((c) => c.status === "Completed").length), ch: "Finished cycles", cl: "#2563eb" },
      { l: "Avg Progress", v: cycles.length ? Math.round(cycles.reduce((a, c) => a + (c.progress || 0), 0) / cycles.length) + "%" : "0%", ch: "Across all cycles", cl: "#d97706" }].
      map((k, i) =>
      <div key={i} className="kpi-c performancepg-dyn-2" style={{ "--performancepg-2-border-left": "3px solid " + k.cl }}>
        <div className="kpi-v performancepg-dyn-3" style={{ "--performancepg-3-color": k.cl }}>{k.v}</div>
        <div className="kpi-l">{k.l}</div>
        <div className="kpi-ch performancepg-dyn-4" style={{ "--performancepg-4-color": k.cl }}>{k.ch}</div>
      </div>
      )}
  </div>

  {/* Cycles Table */}
  <div className="cd"><div className="cd-h"><div className="cd-t">Review Cycles</div><div className="cd-s">{cycles.length} total</div></div>
  <div className="cd-b performancepg-inline-5">
    <table className="tbl"><thead><tr><th>Cycle ID</th><th>Name</th><th>Start</th><th>End</th><th>Status</th><th>Progress</th><th>Reviews</th><th>Actions</th></tr></thead>
    <tbody>
      {cycles.length === 0 ? <tr><td colSpan="8" style={{ "--performancepg-5-color": T.textMuted }} className="performancepg-dyn-5">No performance cycles found. Create one to get started.</td></tr> :
            cycles.map((c) =>
            <tr key={c.cycle_id}>
          <td className="performancepg-inline-6">{c.cycle_id}</td>
          <td className="performancepg-inline-7">{c.name}</td>
          <td className="performancepg-inline-8">{fmtDate(c.start_date)}</td>
          <td className="performancepg-inline-9">{fmtDate(c.end_date)}</td>
          <td><span className={"chip " + (c.status === "Completed" ? "chip-ok" : c.status === "In Progress" ? "chip-ip" : "chip-wn")}>{c.status}</span></td>
          <td>
            <div className="performancepg-inline-10">
              <div style={{ "--performancepg-6-background": T.border }} className="performancepg-dyn-6">
                <div style={{ "--performancepg-7-width": (c.progress || 0) + "%", "--performancepg-7-background": c.progress >= 80 ? "#2563eb" : c.progress >= 40 ? "#d97706" : "#ef4444" }} className="performancepg-dyn-7" />
              </div>
              <span style={{ "--performancepg-8-color": c.progress >= 80 ? "#2563eb" : "#d97706" }} className="performancepg-dyn-8">{c.progress || 0}%</span>
            </div>
          </td>
          <td className="performancepg-inline-11">{c.completed_reviews || 0}/{c.total_reviews || 0}</td>
          <td>
            <div className="performancepg-inline-12">
              <button className="btn-o btn-s" onClick={() => viewReviews(c)} title="View Reviews">{II("eye", 14)}</button>
              {c.status === "Draft" && <button className="btn btn-s btn-ok" onClick={() => updateStatus(c.cycle_id, "In Progress")} title="Start">{II("arrow", 14)}</button>}
              {c.status === "In Progress" && <button className="btn btn-s performancepg-dyn-9" style={{ "--performancepg-9-background": T.success }} onClick={() => updateStatus(c.cycle_id, "Completed")} title="Complete">{II("chk", 14)}</button>}
              {c.status === "Draft" && <button className="btn btn-s btn-dn" onClick={() => deleteCycle(c.cycle_id)} title="Delete">{II("x", 14)}</button>}
            </div>
          </td>
        </tr>
            )}
    </tbody></table>
  </div></div>

  {/* Create Cycle Modal */}
  <HrModal open={showCreate} onClose={() => setShowCreate(false)} title="Create Performance Cycle">
    <div className="fg"><label className="fl">Cycle Name *</label><input className="fi" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="e.g. FY 2025-26 H2" /></div>
    <div className="fr2">
      <div className="fg"><label className="fl">Start Date</label><input className="fi" type="date" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} /></div>
      <div className="fg"><label className="fl">End Date</label><input className="fi" type="date" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} /></div>
    </div>
    <p style={{ "--performancepg-10-color": T.textLight }} className="performancepg-dyn-10">All active employees and interns will be auto-added to this cycle for review.</p>
    <div className="performancepg-inline-13"><button className="btn-o" onClick={() => setShowCreate(false)}>Cancel</button><button className="btn" onClick={createCycle}>Create Cycle</button></div>
  </HrModal>

  {/* Reviews Modal */}
  <HrModal open={showReviews} onClose={() => {setShowReviews(false);setSelectedCycle(null);}} title={selectedCycle ? `Reviews — ${selectedCycle.name}` : "Reviews"} wide>
  <div className="performancepg-inline-14">
  <table className="tbl"><thead><tr><th>Employee</th><th>ID</th><th>Dept</th><th>Mgr Rating</th><th>Final Rating</th><th>Status</th><th>Action</th></tr></thead>
      <tbody>
        {reviews.length === 0 ? <tr><td colSpan="7" style={{ "--performancepg-11-color": T.textMuted }} className="performancepg-dyn-11">No reviews in this cycle.</td></tr> :
            reviews.map((r) =>
            <tr key={r.id}>
            <td className="performancepg-inline-15">{r.emp_name}</td>
            <td className="performancepg-inline-16">{r.emp_id}</td>
            <td>{r.dept || "—"}</td>
            <td style={{ "--performancepg-12-color": r.mgr_rating > 3 ? "#2563eb" : "#d97706" }} className="performancepg-dyn-12">{r.mgr_rating || "—"}</td>
            <td style={{ "--performancepg-13-color": r.rating > 3 ? "#2563eb" : r.rating > 0 ? "#d97706" : "#94a3b8" }} className="performancepg-dyn-13">{r.rating || "—"}</td>
            <td><span className={"chip " + (r.status === "Completed" ? "chip-ok" : r.status === "Pending" ? "chip-wn" : "chip-ip")}>{r.status}</span></td>
            <td><button className="btn-o btn-s" onClick={() => openEditReview(r)}>{II("edit", 14)}</button></td>
          </tr>
            )}
      </tbody></table>
    </div>
  </HrModal>

  {/* Edit Review Modal */}
  <HrModal open={showEditReview} onClose={() => setShowEditReview(false)} title={selectedReview ? `Review — ${selectedReview.emp_name}` : "Edit Review"}>
    <div className="fr2">
      <div className="fg"><label className="fl">Manager Rating (0-5)</label><input className="fi" type="number" min="0" max="5" step="0.5" value={reviewForm.mgr_rating} onChange={(e) => setReviewForm({ ...reviewForm, mgr_rating: e.target.value })} placeholder="e.g. 4.0" /></div>
      <div className="fg"><label className="fl">Final Rating (0-5)</label><input className="fi" type="number" min="0" max="5" step="0.5" value={reviewForm.rating} onChange={(e) => setReviewForm({ ...reviewForm, rating: e.target.value })} placeholder="e.g. 4.0" /></div>
    </div>
    <div className="fg"><label className="fl">Goals</label><textarea className="fta" value={reviewForm.goals} onChange={(e) => setReviewForm({ ...reviewForm, goals: e.target.value })} placeholder="Performance goals..." /></div>
    <div className="fg"><label className="fl">Achievements</label><textarea className="fta" value={reviewForm.achievements} onChange={(e) => setReviewForm({ ...reviewForm, achievements: e.target.value })} placeholder="Key achievements..." /></div>
    <div className="fg"><label className="fl">Feedback</label><textarea className="fta" value={reviewForm.feedback} onChange={(e) => setReviewForm({ ...reviewForm, feedback: e.target.value })} placeholder="Feedback and comments..." /></div>
    <div className="fg"><label className="fl">Status</label><select className="fsel" value={reviewForm.status} onChange={(e) => setReviewForm({ ...reviewForm, status: e.target.value })}>
      <option value="Pending">Pending</option>
      <option value="Manager Review">Manager Review</option>
      <option value="Completed">Completed</option>
    </select></div>
    <div className="performancepg-inline-17"><button className="btn-o" onClick={() => setShowEditReview(false)}>Cancel</button><button className="btn" onClick={saveReview}>Save Review</button></div>
  </HrModal>
  </div>;
}

export default PerformancePg;